import { IAxiosInstance } from "clients/AbstractApiClient/AbstractApiClient";

export const getContractorPaymentGroups =
  (axios: IAxiosInstance) =>
  async ({
    year,
    paymentGroupID,
  }: {
    year: string;
    paymentGroupID?: string;
  }) => {
    const response = await axios.noRetry.get("/contractor-payment-groups", {
      params: {
        year,
        paymentGroupID,
      },
    });
    return response.data;
  };
